import React, {useState, useEffect} from 'react';
import axios from 'axios';

import { useLocation, useNavigate } from 'react-router-dom';

import "./FormsView.css";
import DashboardNavBar from '../../Components/DashboardNavbar/DashboardNavbar';
import AssignModal from '../../Components/Modals/AssignModal';

import { Slider, Radio, RadioGroup, FormControlLabel, FormControl } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import AssignmentIcon from '@mui/icons-material/Assignment';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import EditIcon from '@mui/icons-material/Edit';
import SaveIcon from '@mui/icons-material/Save';
import DeleteIcon from '@mui/icons-material/Delete';
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import CancelIcon from '@mui/icons-material/Cancel';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

function FormsView() {

  const [edit, setEdit] = useState(false);
  const [selectedForm, setSelectedForm] = useState({});
  const [selectedFormIndex, setSelectedFormIndex] = useState(0);
  const [removedQuestions, setRemovedQuestions] = useState([]);
  const [forms, setForms] = useState([]);

  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  let navigate = useNavigate();
  const { state } = useLocation();

  const questionTypes = {
    "free_response": "Free Response",
    "multiple_choice": "Multiple Choice",
    "likert": "Likert",
    "multiple_select": "Multiple Select",
    "group_survey": "Group Survey",
  }

  const staticFormNames = {
    "-1": "Project Selection",
    // "-2": "CDR",
    "-3": "Project Submission",
  }

  async function loadForms() {
    const response = await axios.get(`${process.env.REACT_APP_API_HOST}/api/forms/templates/${state.department}`, 
    { headers: {Authorization: `Bearer ${state.token.access_token}`} });
    setForms(response.data);
  }

  function loadSelectedForm(formIndex) {
    if (formIndex < 0) {
      setSelectedForm({
        title: staticFormNames[formIndex],
        template_id: formIndex,
      })
    }
    else {
      setSelectedForm(JSON.parse(JSON.stringify({...forms[formIndex]})));
    }
  }

  async function createNewForm() {
    const response = await axios.post(`${process.env.REACT_APP_API_HOST}/api/forms/templates/${state.department}`, 
      {
        title: "New Form",
        department: state.department,
        questions: [] 
      },
      { headers: {Authorization: `Bearer ${state.token.access_token}`} }
    );

    let currentForms = forms;
    currentForms.push({
      template_id: response.data.template_id,
      title: "New Form",
      isAssigned: false,
      questions: []
    });
    setForms([...currentForms]);
    setSelectedFormIndex(currentForms.length-1);
    setEdit(true);
  }

  async function duplicateForm() {
    const response = await axios.post(`${process.env.REACT_APP_API_HOST}/api/forms/templates/${state.department}`,
      {
        title: selectedForm.title + "(Copy)",
        questions: [...selectedForm.questions]
      },
      { headers: {Authorization: `Bearer ${state.token.access_token}`} }
    );

    let currentForms = forms;
    currentForms.splice(selectedFormIndex+1, 0, {
      template_id: response.data.template_id,
      title: selectedForm.title + "(Copy)",
      isAssigned: false,
      questions: [...response.data.questions]
    });
    setForms([...currentForms]);
    setSelectedFormIndex(selectedFormIndex+1);
  }

  function selectForm(formIndex) {
    cancelChanges();
    setSelectedFormIndex(formIndex);
  }
  
  function updateTitle(value) {
    let currentForm = selectedForm;
    currentForm.title = value;
    setSelectedForm({...currentForm});
  }

  async function saveForm() {
    const response = await axios.put(
      `${process.env.REACT_APP_API_HOST}/api/forms/templates`,
      {...selectedForm, removedQuestions: removedQuestions},
      { headers: {Authorization: `Bearer ${state.token.access_token}`} }
    );
    setSelectedForm(response.data);

    let currentForms = forms;
    currentForms[selectedFormIndex] = {...response.data};
    setForms([...currentForms]);
    setEdit(false);
  }

  function cancelChanges() {
    loadSelectedForm(selectedFormIndex);
    setEdit(false);
    setRemovedQuestions([]);
  }

  async function deleteForm(formIndex) {
    let currentForms = forms;
    if (formIndex > 0)
      setSelectedFormIndex(formIndex - 1)
    currentForms.splice(formIndex, 1);
    setForms([...currentForms]);

    await axios.delete(`${process.env.REACT_APP_API_HOST}/api/forms/templates/${selectedForm.template_id}`,
      { headers: {Authorization: `Bearer ${state.token.access_token}`}} 
    );
  }

  function addQuestion() {
    let currentForm = selectedForm;
    currentForm.questions.push({
      type: "free_response",
      text: "",
      answers: [""],
    })
    setSelectedForm({...currentForm});
  }

  function deleteQuestion(questionIndex) {
    let currentForm = selectedForm;
    if (currentForm.questions[questionIndex].question_id)
      setRemovedQuestions([...removedQuestions, currentForm.questions[questionIndex].question_id])
    currentForm.questions.splice(questionIndex, 1);
    setSelectedForm({...currentForm});
  }

  function updateQuestion(questionIndex, key, value) {
    let currentForm = selectedForm;
    currentForm.questions[questionIndex][key] = value;
    setSelectedForm({...currentForm});
  }

  function addAnswer(questionIndex) {
    let currentForm = selectedForm;
    currentForm.questions[questionIndex].answers.push("");
    setSelectedForm({...currentForm});
  }

  function deleteAnswer(questionIndex, answerIndex) {
    let currentForm = selectedForm;
    currentForm.questions[questionIndex].answers.splice(answerIndex, 1);
    setSelectedForm({...currentForm});
  }

  function updateAnswer(questionIndex, answerIndex, answer) {
    let currentForm = selectedForm;
    currentForm.questions[questionIndex].answers[answerIndex] = answer;
    setSelectedForm({...currentForm});
  }

  useEffect(() => {
    loadForms();
  }, [])

  useEffect(() => {
    loadSelectedForm(selectedFormIndex);
  }, [forms, selectedFormIndex])

  return (
    <>
      <DashboardNavBar userType="admin" />
      <div style={{display: 'flex'}}>
        <div className='saved-assignments'>
          <div>
            <h3>Static Forms</h3>
          </div>
          <ul>
            <li onClick={() => selectForm(-1)} className={-1 === selectedFormIndex ? "selected" : ""}>Project Selection</li>
            {/* <li onClick={() => selectForm(-2)} className={-2 === selectedFormIndex ? "selected" : ""}>CDR</li> */}
            <li onClick={() => selectForm(-3)} className={-3 === selectedFormIndex ? "selected" : ""}>Final Submission</li>
          </ul>
          <div>
            <h3>Saved Forms</h3>
            <button className="icon" onClick={createNewForm}> 
              <AddIcon sx={{ fontSize: 20 }}/>
              New
            </button>
          </div>
          <ul>
            {
              forms.length > 0 && forms.map((form, index) => (
                <li key={index} onClick={() => selectForm(index)} className={form.isAssigned ? "assigned" : index === selectedFormIndex ? "selected" : ""}>
                  {form.title}
                </li>
              ))
            }
          </ul>
        </div>
        <div className='form-container'>
          <div className='controls'>
            <div>
              <button className="icon" onClick={() => navigate("/assignments", { state: state })}>
                <ArrowBackIcon sx={{ fontSize: 20 }} />
                View Assignments
              </button>
              <button className="icon" onClick={handleOpen}>
                <AssignmentIcon sx={{ fontSize: 20 }}/>
                Assign to Class
              </button>
            </div>
            <div>
              {
                edit ?
                <>
                  <button className="icon" onClick={cancelChanges}>
                    <CancelIcon sx={{ fontSize: 20 }}/>
                    Cancel
                  </button>              
                  <button className="icon" onClick={saveForm}>
                    <SaveIcon sx={{ fontSize: 20 }}/>
                    Save
                  </button>
                </>
                :
                <button className="icon" onClick={() => setEdit(true)}>
                  <EditIcon sx={{ fontSize: 20 }}/>
                  Edit
                </button>
              }
              <button className="icon" onClick={duplicateForm}>
                <ContentCopyIcon sx={{ fontSize: 20 }}/>
                Duplicate
              </button>
              <button className="icon" style={{backgroundColor: "#E42B2B"}} onClick={() => deleteForm(selectedFormIndex)}>
                <DeleteIcon sx={{ fontSize: 20 }}/>
                Delete
              </button>
            </div>
          </div>
          <div className='form'>
            {
              edit ?
              <div style={{display: "flex", marginBottom: "1rem", alignItems: "baseline"}}>
                <h2>Title:</h2>
                <input placeholder='What is the name of the form?' value={selectedForm.title} onChange={(event) => updateTitle(event.target.value)} style={{maxWidth: "600px", borderBottom: "1px solid black", fontSize: "1.4rem", fontWeight: "bold", borderRadius: 0}}/>
              </div>
              :
              <div style={{display: "flex",  marginBottom: "1rem"}}>
                <h2>Title: {selectedForm.title}</h2>
              </div>
            }
            <ul>
              {
                selectedForm.questions && selectedForm.questions.map((question, questionIndex) => (
                  (edit ?
                    <li key={questionIndex}>
                      <div style={{display: "flex"}}>
                        <p>Type: </p>
                        <select name="question-type" value={question.type} onChange={(event) => updateQuestion(questionIndex, "type", event.target.value)}>
                          <option value="free_response">Free Response</option>
                          <option value="likert">Likert</option>
                          <option value="multiple_choice">Multiple Choice</option>
                          <option value="multiple_select">Multiple Select</option>
                          <option value="group_survey">Group Survey</option>
                        </select>
                        <button className='remove' onClick={() => deleteQuestion(questionIndex)}>
                          <RemoveCircleIcon sx={{ fontSize: 20 }}/>
                          Remove Question
                        </button>
                      </div>
                      <div style={{display: "flex", marginTop: "8px"}}>
                        <h5>Question: </h5>
                        <input placeholder='What is the question you are asking?' value={question.text} onChange={(event) => updateQuestion(questionIndex, "text", event.target.value)} style={{padding: "8px", maxWidth: "600px"}}/>
                      </div>
                      {
                        (question.type === "likert") ?
                        <>
                          <h5>Answer Choices: </h5>
                          <FormControl sx={{display: "flex", alignItems: "center"}}>
                            <RadioGroup
                                row
                                aria-labelledby={"likert-scale"}
                            >
                                <FormControlLabel control={<Radio/>} label="Strongly Agree" labelPlacement="top"/>
                                <FormControlLabel control={<Radio/>} label="Agree" labelPlacement="top"/>
                                <FormControlLabel control={<Radio/>} label="Neutral" labelPlacement="top"/>
                                <FormControlLabel control={<Radio/>} label="Disagree" labelPlacement="top"/>
                                <FormControlLabel control={<Radio/>} label="Strongly Disagree" labelPlacement="top"/>
                            </RadioGroup>
                          </FormControl>
                        </>
                        : null
                      }
                      {
                        (question.type === "multiple_choice" || question.type === "multiple_select") &&
                        <>
                          <h5>Answer Choices: </h5>
                          <ul style={{listStyle: "disc"}}>
                          {
                            question.answers.map((answerChoice, answerIndex) => (
                              <li key={answerIndex} className="answer-choice" style={{display: "flex", alignItems: "center", marginTop: "5px"}}>
                                <input placeholder='Enter an answer choice' value={answerChoice} onChange={(event) => updateAnswer(questionIndex, answerIndex, event.target.value)} style={{padding: "8px"}}/>
                                <HighlightOffIcon sx={{ fontSize: 20, mx: 2 }} onClick={() => deleteAnswer(questionIndex, answerIndex)} />
                              </li>
                            ))
                          }
                          </ul>
                          <button className='add' onClick={() => addAnswer(questionIndex)}>Add Answer</button>
                        </>
                      }
                      {
                        (question.type === "group_survey") &&
                        <>
                          <h5>Answer Choices: </h5>
                          <p>This question will have responses for each team member</p>
                          <div style={{display: "flex", alignItems: "baseline", gap: 32, paddingInline: 32}}>
                            <p style={{whiteSpace: "nowrap"}}>Group Member</p>
                            <Slider
                              aria-label="sample-answer"
                              defaultValue={5}
                              valueLabelDisplay="auto"
                              marks={[{value: 0, label: "0"}, {value: 5, label: "5"}, {value: 10, label: "10"}]}
                              step={1}
                              min={0}
                              max={10}
                            />
                          </div>
                        </>
                      }
                    </li>
                    :
                    <li key={questionIndex}>
                      <p>Type: {questionTypes[question.type]}</p>
                      <h5>{question.text}</h5>
                      {
                        question.type === "likert" ?
                        <>
                          <h5>Answer Choices: </h5>
                          <FormControl sx={{display: "flex", alignItems: "center"}}>
                            <RadioGroup
                                row
                                aria-labelledby={"likert-scale"}
                            >
                                <FormControlLabel disabled control={<Radio/>} label="Strongly Agree" labelPlacement="top"/>
                                <FormControlLabel disabled control={<Radio/>} label="Agree" labelPlacement="top"/>
                                <FormControlLabel disabled control={<Radio/>} label="Neutral" labelPlacement="top"/>
                                <FormControlLabel disabled control={<Radio/>} label="Disagree" labelPlacement="top"/>
                                <FormControlLabel disabled control={<Radio/>} label="Strongly Disagree" labelPlacement="top"/>
                            </RadioGroup>
                          </FormControl>
                        </>
                        : null
                      }
                      {
                        (question.type === "multiple_choice" || question.type === "multiple_select") ?
                        <>
                          <h5>Answer Choices: </h5>
                          <ul style={{listStyle: "disc"}}>
                          {
                            question.answers.map((answerChoice, index) => (
                            <li key={index} className="answer-choice">
                              <p>{answerChoice}</p>
                            </li>
                            ))
                          }
                          </ul>
                        </>
                        : null
                      }
                      {
                        question.type === "group_survey" ?
                        <>
                          <h5>Answer Choices: </h5>
                            <p>This question will have responses for each team member</p>
                            <div style={{display: "flex", alignItems: "baseline", gap: 32, paddingInline: 32}}>
                              <p style={{whiteSpace: "nowrap"}}>Group Member</p>
                              <Slider
                                aria-label="sample-answer"
                                defaultValue={5}
                                valueLabelDisplay="auto"
                                marks={[{value: 0, label: "0"}, {value: 5, label: "5"}, {value: 10, label: "10"}]}
                                step={1}
                                min={0}
                                max={10}
                                disabled
                              />
                            </div>
                        </>
                        : null
                      }
                    </li>
                  )
                ))
              }
            </ul>
            {edit && <button className='add' onClick={addQuestion}>Add Question</button>}
          </div>
        </div>
        <AssignModal open={open} handleClose={handleClose} state={state} template={selectedForm} />
      </div>
    </>
  ); 
}

export default FormsView;